export function isChunkLoadError(error: unknown): boolean {
  const message = (error as { message?: string })?.message || String(error)
  const filename = (error as { filename?: string })?.filename || ""

  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Loading chunk") ||
    message.includes("Loading CSS chunk") ||
    message.includes("Importing a module script failed") ||
    message.includes("error loading dynamically imported module") ||
    filename.includes("/assets/")
  )
}
